import { useCallback, useEffect, useState } from 'react';

import {
  registerUnmutedVideo,
  unregisterUnmutedVideo,
} from '@/utils/media/videoMuteCoordinator';

interface UseFeedAudioParams {
  activeIndex: number;
}

const useFeedAudio = ({ activeIndex }: UseFeedAudioParams) => {
  const [isMuted, setIsMuted] = useState(true);
  const [hasAudioBySlideIndex, setHasAudioBySlideIndex] = useState<
    Record<number, boolean>
  >({});

  const muteThisFeed = useCallback(() => setIsMuted(true), []);

  const toggleMute = useCallback(() => setIsMuted((prev) => !prev), []);

  useEffect(() => {
    if (isMuted) return undefined;
    registerUnmutedVideo(muteThisFeed);
    return () => unregisterUnmutedVideo(muteThisFeed);
  }, [isMuted, muteThisFeed]);

  const reportSlideAudio = useCallback(
    ({ index, hasAudio }: { index: number; hasAudio: boolean }) => {
      setHasAudioBySlideIndex((prev) =>
        prev[index] === hasAudio ? prev : { ...prev, [index]: hasAudio }
      );
    },
    []
  );

  return {
    isMuted,
    toggleMute,
    activeSlideHasAudio: Boolean(hasAudioBySlideIndex[activeIndex]),
    reportSlideAudio,
  };
};

export default useFeedAudio;
